import React from "react";

import { useTranslation } from "react-i18next";

import { useDevice } from "@utils";

import { TeamsHeader, TeamsInfoItem } from "@ui/components";
import {
  Box,
  Table,
  TableData,
  TableHeading,
  TableRow,
  Tag,
  Text,
} from "@ui/elements";

export const TipTableSkeleton = () => {
  const { t } = useTranslation();

  return (
    <Table isStriped={false}>
      <TableRow>
        <TableHeading>{t("tip-name")}</TableHeading>
        <TableHeading>{t("probability-short")}</TableHeading>
        <TableHeading>{t("odds")}</TableHeading>
        <TableHeading>{t("stake")}</TableHeading>
        <TableHeading></TableHeading>
      </TableRow>
      <TableRow>
        <TableData>
          <Text isLoading>Over 0.5 Goals</Text>
        </TableData>
        <TableData>
          <Text isLoading>
            <Tag size="medium" isLoading>
              80%
            </Tag>
          </Text>
        </TableData>
        <TableData>
          <Text isLoading>x2.02</Text>
        </TableData>
        <TableData>
          <Text isLoading>4.22%</Text>
        </TableData>
        <TableData>
          <Text isLoading>5.19%</Text>
        </TableData>
      </TableRow>
      <TableRow>
        <TableData>
          <Text isLoading>Over 0.5 Goals</Text>
        </TableData>
        <TableData>
          <Text isLoading>
            <Tag size="medium" isLoading>
              80%
            </Tag>
          </Text>
        </TableData>
        <TableData>
          <Text isLoading>x2.02</Text>
        </TableData>
        <TableData>
          <Text isLoading>4.22%</Text>
        </TableData>
        <TableData>
          <Text isLoading>5.19%</Text>
        </TableData>
      </TableRow>
      <TableRow>
        <TableData>
          <Text isLoading>Over 0.5 Goals</Text>
        </TableData>
        <TableData>
          <Text isLoading>
            <Tag size="medium" isLoading>
              80%
            </Tag>
          </Text>
        </TableData>
        <TableData>
          <Text isLoading>x2.02</Text>
        </TableData>
        <TableData>
          <Text isLoading>4.22%</Text>
        </TableData>
        <TableData>
          <Text isLoading>5.19%</Text>
        </TableData>
      </TableRow>
    </Table>
  );
};

export const TipCardSkeleton = () => {
  const device = useDevice();
  const { t } = useTranslation();

  if (device === "mobile") {
    return (
      <Box
        header={
          <TeamsHeader
            isLoading
            title="Bahia vs Botafogo"
            subtitle={
              <>
                <TeamsInfoItem isLoading icon="Trophy" label="08 August" />
                <TeamsInfoItem isLoading icon="Trophy" label="00:00" />
                <TeamsInfoItem isLoading icon="Trophy" label="Copa do Brasil" />
              </>
            }
            score="2-2"
          />
        }
      >
        <TipTableSkeleton />
      </Box>
    );
  }

  return (
    <Box
      header={
        <TeamsHeader
          isLoading
          title="Bahia vs Botafogo"
          subtitle={
            <>
              <TeamsInfoItem isLoading icon="Trophy" label="08 August" />
              <TeamsInfoItem isLoading icon="Trophy" label="00:00" />
              <TeamsInfoItem isLoading icon="Trophy" label="Copa do Brasil" />
            </>
          }
          score="2-2"
        />
      }
    >
      <Table isStriped={false}>
        <TableRow>
          <TableHeading>{t("tip-name")}</TableHeading>
          <TableHeading>{t("probability")}</TableHeading>
          <TableHeading>{t("odds")}</TableHeading>
          <TableHeading>{t("stake")}</TableHeading>
          <TableHeading></TableHeading>
        </TableRow>
        <TableRow>
          <TableData>
            <Text isLoading>Both Teams to Score</Text>
          </TableData>
          <TableData>
            <Tag size="medium" isLoading>
              Risky
            </Tag>
          </TableData>
          <TableData>
            <Text isLoading>80%</Text>
          </TableData>
          <TableData>
            <Text isLoading>x2.02</Text>
          </TableData>
          <TableData>
            <Text isLoading>4.22%</Text>
          </TableData>
          <TableData>
            <Text isLoading>5.19%</Text>
          </TableData>
        </TableRow>
        <TableRow>
          <TableData>
            <Text isLoading>Both Teams to Score</Text>
          </TableData>
          <TableData>
            <Tag size="medium" isLoading>
              Risky
            </Tag>
          </TableData>
          <TableData>
            <Text isLoading>80%</Text>
          </TableData>
          <TableData>
            <Text isLoading>x2.02</Text>
          </TableData>
          <TableData>
            <Text isLoading>4.22%</Text>
          </TableData>
          <TableData>
            <Text isLoading>5.19%</Text>
          </TableData>
        </TableRow>
        <TableRow>
          <TableData>
            <Text isLoading>Both Teams to Score</Text>
          </TableData>
          <TableData>
            <Tag size="medium" isLoading>
              Risky
            </Tag>
          </TableData>
          <TableData>
            <Text isLoading>80%</Text>
          </TableData>
          <TableData>
            <Text isLoading>x2.02</Text>
          </TableData>
          <TableData>
            <Text isLoading>4.22%</Text>
          </TableData>
          <TableData>
            <Text isLoading>5.19%</Text>
          </TableData>
        </TableRow>
      </Table>
    </Box>
  );
};
